<template>
  <div v-if="property">
    <div v-if="property?.numBathrooms || property?.maxOccupancy">
      <ion-row class="ion-justify-content-between ion-align-items-center price-subtitle nowrap">
        <div v-if="property?.numBathrooms">
          <h3 class="font-sm bold-medium grey">{{ t('announcement.numBath') }}</h3>
          <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
            <ion-icon :icon="waterOutline" class="medium-icon" color="grey"></ion-icon>
            <p class="padding-list-item">
              {{ property?.numBathrooms }}
              {{
                property?.numBathrooms === 1
                  ? t('announcement.bathroom')
                  : t('announcement.numBath')
              }}
            </p>
          </ion-row>
        </div>
        <div v-if="property?.maxOccupancy" class="padding-list-item">
          <h3 class="font-sm bold-medium grey">{{ t('announcement.maxCap') }}</h3>
          <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
            <ion-icon :icon="peopleOutline" class="medium-icon" color="grey"></ion-icon>
            <p class="padding-list-item">
              {{ property?.maxOccupancy }} {{ t('announcement.people') }}
            </p>
          </ion-row>
        </div>
      </ion-row>
    </div>

    <div v-if="property?.areaM2">
      <ion-row class="ion-justify-content-between ion-align-items-center price-subtitle nowrap">
        <div v-if="property?.areaM2">
          <h3 class="font-sm bold-medium grey">{{ t('announcement.totalArea') }}</h3>
          <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
            <ion-icon :icon="businessOutline" class="medium-icon" color="grey"></ion-icon>
            <p class="padding-list-item">{{ property?.areaM2 }} {{ property?.typeSize }}</p>
          </ion-row>
        </div>
      </ion-row>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Property } from '@/interfaces/elastic/elastic.interface';
  import { IonRow, IonIcon } from '@ionic/vue';
  import { peopleOutline, businessOutline, waterOutline } from 'ionicons/icons';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  withDefaults(
    defineProps<{
      property?: Property;
    }>(),
    {},
  );
</script>

<style lang="css" scoped></style>
